export const blue = '#1C59D7'
export const brandBlue = '#2D459F'
export const gray = '#4A4A4A'
export const blueText = '#2347AD'
export const blackText = '#444444'
export const lightGray = '#CCC'
